import * as React from "react";

interface Props {
  size?: number;
  color?: string;
}

const ChevronLeftIconV1 = ({ size = 18, color = "currentColor" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

export default ChevronLeftIconV1;
